import '/modules/edid/css/tumboEdidSearch.css';
import '/modules/edid/css/tumboEdidSearch.responsive.css';
import {Loader} from "../common/ui/Loader";
import {EdidSearchConfig, EdidSearchRuntimeConfig} from "./config/EdidSearchConfig";
import {MainTumboApplication} from "../common/main/MainTumboApplication";
import {EdidRecordContainer} from "./ui/EdidRecordContainer";
import {EdidTableContainer} from "./ui/EdidTableContainer";


/**
 * A Tumbo EDID search application point of entry
 * @extends MainTumboApplication
 * @hideconstructor
 */
class TumboEdidSearch extends MainTumboApplication {

    getClassName() {
        return "TumboEdidSearch";
    }

    _readConfig() {
        return new EdidSearchConfig(this.config);
    }

    _getRuntimeConfigSerializationKey() {
        return 'edidSearchRuntimeConfig_' + this.parsedConfig.getCode();
    }

    _getRuntimeConfig() {
        return new EdidSearchRuntimeConfig(this.parsedConfig.getCode(), undefined);
    }

    _getRuntimeConfigFromSerialization(runtimeConfigSerialization) {
        return EdidSearchRuntimeConfig.createFromSerialized(this.parsedConfig.getCode(), runtimeConfigSerialization);
    }

    _doRun() {
        this.target.addClass('edid-search-app');
        this._generateDOMStructure();

        this.loader = new Loader('searchLoader',this.target);

        const urlSearchParams = new URLSearchParams(window.location.search);
        const recordId = urlSearchParams.has('id')?Number(urlSearchParams.get('id')):undefined;
        if(recordId)
            this._generateRecordForm(recordId,urlSearchParams.has('fromTable'));
        else this._generateRecordsTable();
    }

    _generateDOMStructure() {
        this.container = $('<ul role="list" class="container-ul"></ul>');
        this.outerContent = $('<div class="outer-content"><h1>' + this.parsedConfig.getName() + '</h1></div>');
        this.target.append(this.outerContent);
        this.outerContent.append(this.container);
    }

    _generateRecordForm(id,fromTable){
        this.loader.show();
        $('li.table-container',this.container).remove();
        $('li.record-container',this.container).remove();
        this.fetcherFactory.getFetcher(this.parsedConfig.getRecordsByIdServiceUrl().format([id]))
            .success(data=>{
                const edidRecordContainer = new EdidRecordContainer('edid_record_container',data,()=>this._generateRecordsTable());
                this.container.append(edidRecordContainer.getUIElement().addClass('record-container'));
                edidRecordContainer.add2DOM();
                this.loader.hide();
                if(!fromTable)
                    this.logStat('OPEN_RECORD_FROM_URL {'+id+'}');
            })
            .error((textStatus, error) => {
                this.loader.hide();
                this.logError("Error loading record with id " + id+': '+textStatus, error);
            })
            .fetch();
    }

    _generateRecordsTable(){
        $('li.record-container',this.container).remove();
        const edidTableContainer = new EdidTableContainer('edid_table_container', this.parsedConfig.getSearchRecordsServiceUrl(), this.parsedConfig.getRegionsServiceUrl(), this.parsedConfig.getRecordsByIdServiceUrl(), this.parsedConfig.getTableContextInfo());
        this.container.append(edidTableContainer.getUIElement().addClass('table-container'));
        edidTableContainer.add2DOM();
        window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
    }

}

export {TumboEdidSearch}